import * as React from "react"
import {Box, LinearProgress, Typography} from "@mui/material"
import {ImageSeeker} from "@ui-seeker/core"

import {blockStyles, boxFrameStyles, iframeStyles, mockStyles} from "./styles"


export default function BannersIframe ({ isLoading, idSearch, type }) {

    if (isLoading) return <LoadingIframeCell />
    return <Box sx={{...blockStyles}}>
        <ImageSeeker src="/images/phoneFrame.png" alt="" sx={{...mockStyles}} />
        <Box sx={{...boxFrameStyles}}>
            <iframe
                id="resizable-iframe"
                src={`/api/v2/redirect-screenshot-html/${type}/${idSearch}/${2}`}
                sandbox="allow-scripts allow-popups allow-same-origin"
                allowFullScreen
                style={{...iframeStyles}}
            />
        </Box>
    </Box>
}

const LoadingIframeCell = () => <Box sx={{ width: '400px', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0 auto' }}>
    <Typography component="div" variant="body" fontStyle="italic" sx={{ mb: 3, textAlign: 'center' }}>
        Loading...
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress />
        </Box>
    </Box>
</Box>
